let _ = t => t,
  _t;
import { css } from 'styled-components';
export const breakPoints = {
  XS: 575,
  SM: 768,
  MD: 992,
  LG: 1200,
  XLG: 1366
};
export const mediaQuery = (selector, px) => (strings, ...args) => css(_t || (_t = _`
            @media (${0}: ${0}px) {
                ${0}
            }
        `), selector, px, css(strings, ...args));
const media = {
  XS: (strings, ...args) => mediaQuery('max-width', breakPoints.XS)(strings, ...args),
  SM: (strings, ...args) => mediaQuery('max-width', breakPoints.SM)(strings, ...args),
  MD: (strings, ...args) => mediaQuery('max-width', breakPoints.MD)(strings, ...args),
  LG: (strings, ...args) => mediaQuery('max-width', breakPoints.LG)(strings, ...args),
  lessThen: width => mediaQuery('max-width', width),
  moreThen: width => mediaQuery('min-width', width)
};
export default media;